// ----------------------------------------------------------------------
// Global Dashboard Translations - English
// ----------------------------------------------------------------------

export const globalDashboardEn = {
  global_dashboard: {
    // Page title
    page_title: 'Dashboard',

    // Welcome messages by role
    welcome: {
      owner: 'Manage your business from here',
      ambassador: 'Ready to promote some amazing events?',
      referral: 'Check out new events to share and earn',
      waiter: "Let's manage those tables efficiently",
      default: 'Your dashboard is ready',
    },

    // Contextual info alerts
    context_info: {
      event_mode_title: 'Event Management Focus',
      event_mode_description: 'You are in event management mode. Switch to restaurant or music studio mode in settings if needed.',
      restaurant_mode_title: 'Restaurant Management Focus',
      restaurant_mode_description: 'You are in restaurant management mode. Switch to event or music studio mode in settings if needed.',
      music_studio_mode_title: 'Music Studio Management Focus',
      music_studio_mode_description: 'You are in music studio management mode. Switch to event or restaurant mode in settings if needed.',
    },

    // Dashboard modules
    modules: {
      events_management: 'Events Management',
      events_description: 'Create, manage and track your events',
      organizations: 'Organizations',
      organizations_description: 'Manage your organizations and settings',
      restaurants: 'Restaurants',
      restaurants_description: 'Manage restaurants and menus',
      music_studios: 'Music Studios',
      music_studios_description: 'Manage recording studios, bookings and sessions',
      network_team: 'Network & Team',
      network_team_description: 'Invite users, manage team and track referrals',
      ambassador_events: 'Ambassador Events',
      ambassador_events_description: 'View and promote events as an ambassador',
      my_events: 'My Events',
      my_events_description: 'Track your promoted events and earnings',
      table_management: 'Table Management',
      table_management_description: 'Manage restaurant tables and orders',
    },

    // Quick actions
    quick_actions: {
      title: 'Quick Actions',
      create_event: 'Create Event',
      create_organization: 'Create Organization',
      invite_team: 'Invite Team',
      search_events: 'Search Events',
    },

    // Available modules section
    available_modules: 'Available Modules',

    // Buttons
    buttons: {
      open: 'Open',
      manage: 'Manage',
      copy_link: 'Copy Link',
      share: 'Share',
      create_event: 'Create Event',
      create_event_org: 'Create Event Org',
      create_studio: 'Create Studio',
    },

    // Labels
    labels: {
      new: 'New',
      event_org: 'Event Org',
      studio: 'Studio',
    },

    // Enhanced events module
    events_module: {
      title: 'Events Management',
      recent_events: 'recent events',
      click_to_manage: 'Click to manage all',
      no_recent_events: 'No recent events',
      click_to_create: 'Click to create your first event',
      create_first_event: 'Create your first event to get started',
      more_events: 'more events',
    },

    // Event organizations module
    event_orgs_module: {
      title: 'Event Organizations',
      recent_organizations: 'recent organizations',
      no_organizations: 'No event organizations yet',
      create_first_org: 'Create your first event organization',
      followers: 'followers',
    },

    // Music studios module
    music_studios_module: {
      title: 'Music Studios',
      recent_studios: 'recent studios',
      no_studios: 'No music studios yet',
      create_first_studio: 'Create your first music studio',
      services: 'services',
    },

    // Invitation card
    invitation_card: {
      title: 'Invite to Network',
      description: 'Share your invitation link',
      your_link: 'Your invitation link:',
      link_copied: 'Invitation link copied to clipboard!',
      link_copy_failed: 'Failed to copy link',
      share_title: 'Join My Network',
      share_text: 'Join my network and discover amazing events!',
    },

    // Contacts card
    contacts_card: {
      title: 'My Contacts',
      description: 'Manage your contacts',
      access_list: 'Access your contact list',
      add_new: 'Add new contacts',
      send_messages: 'Send emails and messages',
    },

    // Event status chips
    event_status: {
      upcoming: 'upcoming',
      ongoing: 'ongoing',
      past: 'past',
    },

    // Mode chips
    mode: {
      event: 'Event Mode',
      music_studio: 'Music Studio Mode',
      restaurant: 'Restaurant Mode',
    },

    // Footer
    footer: {
      help_text: 'Need help? Check our documentation or contact support.',
    },
  },
};

export default globalDashboardEn;
